import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import type { GetAllCaseAssigneeCandidatesResult } from './get-all-case-assignee-candidates.result';

@Injectable({ providedIn: 'root' })
export class GetAllCaseAssigneeCandidatesUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(caseIds: string[]): Observable<GetAllCaseAssigneeCandidatesResult> {
    return this._repository
      .getBulkCaseAssignmentOptions(caseIds)
      .pipe(map((candidates) => ({ candidates })));
  }
}
